import { BlobProvider } from "@react-pdf/renderer";
import { Button } from "antd";

import DownloadIcon from "@/icons/DownloadIcon";
import PDF from "../../PDF";

const PDFButton = ({
  data,
  navs,
  screenshots,
  config,
  color,
  variant,
  iconColor,
  textColor,
}) => {
  return (
    <BlobProvider
      document={
        <PDF
          data={data}
          navs={navs}
          config={config}
          screenshots={screenshots}
        />
      }
    >
      {({ blob, url, loading }) => {
        return (
          <div>
            <Button
              className="print-btn"
              color={color}
              variant={variant}
              size="large"
              loading={!blob}
              icon={
                <DownloadIcon
                  style={{
                    fontSize: 16,
                    marginTop: "1px",
                    color: iconColor,
                  }}
                />
              }
              onClick={() => {
                if (loading || !blob || !url) return;
                window.open(url);
              }}
              style={{
                paddingInline: 9,
                fontSize: 13,
                fontWeight: 500,
                color: textColor,
              }}
            >
              PDF
            </Button>
          </div>
        );
      }}
    </BlobProvider>
  );
};

export default PDFButton;
